import Head from "next/head";
import { FLUID_CDN_URL } from "@/lib/constants";

interface UseCheckoutMetadataProps {
  companyName?: string;
  companyFaviconUrl?: string;
}

export function useCheckoutMetadata({
  companyName,
  companyFaviconUrl,
}: UseCheckoutMetadataProps) {
  const title = companyName ? `${companyName} | Checkout` : "Checkout";
  const faviconUrl =
    companyFaviconUrl || `${FLUID_CDN_URL}/images/checkout/icons/FluidLogo.svg`;
  return { title, faviconUrl };
}

interface CheckoutMetadataProps {
  companyName?: string;
  companyFaviconUrl?: string;
}

export function CheckoutMetadata({
  companyName,
  companyFaviconUrl,
}: CheckoutMetadataProps) {
  const { title, faviconUrl } = useCheckoutMetadata({
    companyName,
    companyFaviconUrl,
  });

  return (
    <Head>
      <title>{title}</title>
      <link rel="icon" type="image/svg+xml" href={faviconUrl} />
      <link rel="shortcut icon" href={faviconUrl} />
      <link rel="apple-touch-icon" href={faviconUrl} />
    </Head>
  );
}
